import { stateToast } from '$states/toast.svelte';

export type ToastVariant = 'default' | 'positive' | 'negative' | 'attention';

export interface ToastProps {
  readonly variant: ToastVariant;
  readonly message: string;
  readonly dismissible: boolean;
}

export const showToast = (variant: ToastVariant, message: string, dismissible = false): void => {
  stateToast.set({
    variant,
    message,
    dismissible,
  });
};

export const dismissToast = (): void => {
  stateToast.set(null);
};
